/**
 * The paste window (19/10/2026): always mounted, so it grows from its middle
 * on open and shrinks back on close like the Automation's other windows;
 * its body — and the review it asks for — exists only while open. Centred
 * by margins (see OptimizerDialog: the zoom animation replaces a translate),
 * as tall as its content up to the screen, 16px from the edges on a phone;
 * one column since 27/10/2026, so 820px at most.
 * Only Cancel, ✕ or Escape close it: a click beside it (easy while the
 * review still loads and the window is small) must not lose the choices.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Drawer, DrawerContent } from '@/components/ui';
import { cn } from '@/lib/utils';

import { PasteDialogBody, type PasteDialogProps } from './PasteDialogBody';

const WINDOW = cn(
  'inset-0 m-auto translate-x-0 translate-y-0 h-fit max-h-[min(92vh,1000px)]',
  // `!`: the shared dialog's tailwindcss-animate `animate-in/out` would win otherwise.
  'data-[state=open]:!animate-dg-window-in data-[state=closed]:!animate-dg-window-out motion-reduce:!animate-none',
);

interface Props extends PasteDialogProps {
  open: boolean;
  onClose: () => void;
}

export const PasteGroupDialog: FC<Props> = ({ open, onClose, ...body }) => (
  <Drawer open={open} onOpenChange={(next) => !next && onClose()}>
    <DrawerContent
      variant="center"
      width="w-[min(820px,calc(100vw-2rem))]"
      className={WINDOW}
      onInteractOutside={(event) => event.preventDefault()}
    >
      {open ? <PasteDialogBody {...body} onClose={onClose} /> : null}
    </DrawerContent>
  </Drawer>
);
